import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import TopBar from "../components/TopBar";
import SubmitButton from "../components/SubmitButton";
import ErrorImage from "../assets/images/error_payment.png";
import Typography from "@material-ui/core/Typography";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal"
};

const styles = {
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  }
};

class ErrorPayment extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Wrapper>
        <div style={{ margin: "16px", marginTop: "66px" }}>
          <div
            style={{
              marginTop: "32px",
              marginTop: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <img
              alt="error_image"
              src={ErrorImage}
              style={{ width: "120px", height: "120px" }}
            />
          </div>
          <p
            style={{
              ...fontDefault,
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "18px",
              color: "#0e162c"
            }}
          >
            ซื้อประกันไม่สำเร็จ
          </p>
          <p
            style={{
              ...fontDefault,
              textAlign: "center",
              fontSize: "16px",
              color: "#999999"
            }}
          >
            เนื่องจากยอดเงินในวอลเล็ทไม่เพียงพอ กรุณาเติมเงินเข้าวอลเล็ท
            และทำรายการใหม่อีกครั้ง
          </p>
          <br />

          <div
            style={{
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <SubmitButton
              onClick={() => {
                window.location.replace(
                  "ascendmoney://wallet.truemoney.co.th/app/660000000004?type=topup"
                );
              }}
              margin={true}
            >
              เติมเงินเข้าวอลเล็ท
            </SubmitButton>
          </div>
        </div>
        <Header>
          <TopBar
            close={() => {
              window.location.replace("ascendmoney://closewebview");
            }}
          >
            <Typography align="center" className={classes.textTopBar}>
              ประกันภัยไวรัสโคโรนา
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ErrorPayment));
